import { type FC, type ReactNode } from 'react';
import { Link } from 'dibs-elements/exports/Link';
import classNames from 'classnames';

import styles from './IconWrapper.scss';

type Props = {
    onClick?: () => void;
    active?: boolean;
    children: ReactNode;
};

const IconWrapper: FC<Props> = ({ children, active, onClick = () => {} }) => (
    <Link
        className={classNames(styles.iconWrapper, {
            [styles.active]: !!active,
        })}
        onClick={onClick}
    >
        {children}
    </Link>
);

export default IconWrapper;
